//
//
//
//

export default {
  name: 'ContentHtml',

  props: {
    contents: {
      type: String,
      required: true,
    },
  },
};
